import { HCF, HUtils } from "@macashipo/mlib"

export const DefaultWidthID = "40px"
export const DefaultWidthCol = "100px"
export const DefaultWidthColExpand = "30px"
export const DefaultWidthColDelete = "35px"
